module.exports = __webpack_public_path__ + "static/media/one-market-ortho.97d5c655.png";